import { observer } from 'mobx-react-lite';
import ReactHelmet from 'react-helmet';

export const ViewOnlyMode = observer(function ViewOnlyMode() {
	return <ReactHelmet link={[{ rel: 'stylesheet', type: 'text/css', href: '/css/view-only-mode.css' }]} />;
});
